module.exports = __webpack_public_path__ + "img/digitizing5.080e51a6.png";